import { Component, OnInit, Input } from '@angular/core';
import { CMSContentService } from '../../essentials/cms/content/cms-content.service';

@Component({
  selector: 'fcp-exclusive-area',
  templateUrl: './exclusive-area.component.html',
  styleUrls: ['./exclusive-area.component.scss']
})
export class ExclusiveAreaComponent implements OnInit {
  @Input() public positionX: string;
  @Input() public positionY: string;
  @Input() public byFooter: boolean;

  public actions = [];

  constructor(private cmsContentService: CMSContentService) {}

  ngOnInit() {
    this.cmsContentService.getNavActions().subscribe(response => {
      this.actions = response;
    });
  }
}
